// extracted by mini-css-extract-plugin
module.exports = {"viewContent":"HomeLayout_viewContent__1n0Yo"};